/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { Ref } from 'preact/hooks';
import { usePinch } from './usePinch';
import { zoom, ZOOM_INCREMENT } from '../utils/zoomUtils';

type UsePinchZoomOptions = {
  captureTargetRef: Ref<HTMLDivElement>;
  zooming: 'on' | 'off';
  minZoom: number;
  maxZoom: number;
  zoomValue: number;
  onZoom?: (detail: { zoomValue: number }) => void;
};

const usePinchZoom = ({
  captureTargetRef,
  zooming,
  minZoom,
  maxZoom,
  zoomValue,
  onZoom
}: UsePinchZoomOptions) => {
  const pinchProps = usePinch({
    captureTargetRef,
    onPinchZoomChange: ({ delta }) => {
      const newZoom = zoomValue * (1 + ZOOM_INCREMENT * delta);
      zoom(newZoom, zoomValue, minZoom, maxZoom, onZoom);
    },
    isDisabled: zooming === 'off'
  });

  return pinchProps;
};

export { usePinchZoom };
